import type { AdditionalCost, AdditionalCostRequest } from '@api'

import { handleError } from '@/utils/error'

import type { AccountingCostBody } from '../types'
import { useCreateAdditionalCost } from './useCreateAdditionalCost'
import { useUpdateAdditionalCost } from './useUpdateAdditionalCost'

// @ts-ignore
export const isEditing = (cost: unknown): cost is AdditionalCost => !!cost.id

export function useSaveAdditionalCost() {
  const { createCost, isLoading: isCreateLoading } = useCreateAdditionalCost()
  const { updateCost, isLoading: isUpdateLoading } = useUpdateAdditionalCost()

  const saveCost = async (
    costToAdd: Partial<AdditionalCostRequest | AdditionalCost>,
  ) => {
    try {
      if (isEditing(costToAdd)) {
        await updateCost({
          ...costToAdd,
          id: costToAdd.id!,
          retention: costToAdd.retention!,
        })
      } else {
        await createCost(costToAdd as AccountingCostBody)
      }

      return true
    } catch (error) {
      handleError(error, 'Failed to save cost, please try again')
      console.error('Failed to save cost:', error)

      return false
    }
  }

  return {
    saveCost,
    isLoading: isCreateLoading || isUpdateLoading,
  }
}
